import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectTranscript } from '../../redux/slices/callSlice';
import './Transcript.css';

const Transcript = () => {
  const transcript = useSelector(selectTranscript);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [transcript]);

  return (
    <div className="transcript-container">
      <div className="transcript-header">
        <i className="bi bi-chat-dots me-2"></i>Live Transcript
      </div>
      <div className="transcript-messages">
        {transcript.length === 0 ? (
          <div className="transcript-empty">
            <i className="bi bi-chat-square-text"></i>
            <p>Conversation will appear here...</p>
          </div>
        ) : (
          transcript.map((msg, i) => (
            <div key={i} className={`transcript-msg ${msg.role}`}>
              <div className="msg-avatar">
                <i className={`bi ${msg.role === 'assistant' ? 'bi-robot' : 'bi-person'}`}></i>
              </div>
              <div className="msg-content">
                <div className="msg-role">{msg.role === 'assistant' ? 'AI Assistant' : 'You'}</div>
                <div className="msg-text">{msg.content}</div>
              </div>
            </div>
          ))
        )}
        <div ref={bottomRef} />
      </div>
    </div>
  );
};

export default Transcript;
